import { getApiBaseUrl } from './api-base-url';
import { TokenManager } from './token-manager';

let socket: WebSocket | null = null;

export function createSocket() {
  const baseUrl = getApiBaseUrl().replace('http', 'ws');
  const accessToken = TokenManager.getAccessToken();
  const wsUrl = accessToken ? `${baseUrl}?access_token=${accessToken}` : baseUrl;

  socket = new WebSocket(wsUrl);

  socket.onopen = () => {
    console.log('connected');
  };

  socket.onclose = () => {
    console.log('closed');
  };

  socket.onerror = (error: any) => {
    console.log('connect_error', error, error.message);
  };

  socket.onmessage = (event: any) => {
    const eventData = JSON.parse(event.data);
    const message = eventData.message;
    const payload = eventData.payload;
    const eventHandlers = handlers.filter(h => h.message === message);
    for (let i = 0; i < eventHandlers?.length; i++) {
      eventHandlers[i].callback(payload);
    }
  };
}

export function closeSocket() {
  if (socket) {
    socket.close();
    socket = null;
  }
}

class SocketHandler {
  message!: string;
  key!: string;
  callback!: (data: any) => void;
}

const handlers: SocketHandler[] = [];

export function addSocketHandler(message: string, key: string, callback: (data: any) => void, ignoreError = false) {
  if (handlers.some(h => h.message === message && h.key === key)) {
    if (ignoreError) {
      return;
    }
    // TODO - exception can be handled better than this
    throw new Error('Handler aldready exists');
  }

  handlers.push({ message, key, callback });
}

export function removeSocketHandler(message: string, key: string) {
  const index = handlers.findIndex(h => h.message === message && h.key === key);
  if (index < 0) {
    return;
  }
  handlers.splice(index, 1);
}
